module.exports = __webpack_public_path__ + "static/media/radio-btn.aaf553b5.svg";